import type { UserRole } from '~/prisma/enums'

/**
 * @description Checks that the user has exact roles from the allowed list (subset), and no other roles.
 * @param {UserRole[]} userRoles - The user's roles.
 * @param {readonly UserRole[]} allowedRoles - The allowed roles.
 * @returns {boolean} - True if user has exact roles from allowedRoles (can be a subset), false otherwise.
 */
export function hasExactRoles(
  userRoles: UserRole[],
  allowedRoles: readonly UserRole[],
): boolean {
  if (userRoles.length === 0 || allowedRoles.length === 0) {
    return false
  }

  const allowedRolesSet = new Set(allowedRoles)
  // Every user role must exist in the allowedRolesSet
  return userRoles.every(role => allowedRolesSet.has(role))
}
